import { fetchOptions } from './csrf'

export interface CreditAppSetting {
  id: string | null
  enabled: boolean
  credit_app_type: string | null
  notification_email: string | null
  created_at: string | null
  updated_at: string | null
}

interface CreditAppSettingResponse {
  credit_app_setting: CreditAppSetting
}

interface ErrorResponse {
  errors: string[]
}

export const creditAppSettingsApi = {
  async show(): Promise<CreditAppSetting> {
    const response = await fetch('/api/v1/settings/credit-app', fetchOptions())
    if (!response.ok) throw new Error('Failed to load credit app settings')
    const data: CreditAppSettingResponse = await response.json()
    return data.credit_app_setting
  },

  async update(params: Partial<Omit<CreditAppSetting, 'id' | 'created_at' | 'updated_at'>>): Promise<CreditAppSetting> {
    const response = await fetch('/api/v1/settings/credit-app', {
      ...fetchOptions('PUT'),
      body: JSON.stringify({ credit_app_setting: params }),
    })
    if (!response.ok) {
      const data: ErrorResponse = await response.json().catch(() => ({ errors: ['Failed to update settings'] }))
      throw new Error(data.errors.join(', '))
    }
    const data: CreditAppSettingResponse = await response.json()
    return data.credit_app_setting
  },
}
